import { CountryIsoCode } from '../../../types/countryIsoCode'

// 50% split for the demo invoice editor rollout
export const demoInvoiceEditorBuckets = [0, 1, 2, 3, 4, 5]
export const demoInvoiceEditorCountries: Uppercase<CountryIsoCode>[] = ['FR']
